import dayjs from 'dayjs';

import { DATE_PRESETS, type DatePresetId } from '../data/datePresets';

import type { Dayjs } from 'dayjs';

// Pure date/time helpers shared by the lead-card TaskComposer and the unified
// TaskModal so both render the exact same chip label and time math.

export const MONTHS_SHORT_RU = [
  'янв',
  'фев',
  'мар',
  'апр',
  'май',
  'июн',
  'июл',
  'авг',
  'сен',
  'окт',
  'ноя',
  'дек',
];

const pad = (n: number): string => String(n).padStart(2, '0');

export const formatDate = (date: Dayjs): string => {
  const today = dayjs().startOf('day');
  if (date.isSame(today, 'day')) return 'Сегодня';
  if (date.isSame(today.add(1, 'day'), 'day')) return 'Завтра';
  const year = date.year() !== today.year() ? ` ${date.year()}` : '';
  return `${date.date()} ${MONTHS_SHORT_RU[date.month()]}${year}`;
};

export const computeChipLabel = (
  startDate: Dayjs,
  endDate: Dayjs,
  preset: DatePresetId | null,
  isAllDay: boolean,
  startTime: string,
  endTime: string
): string => {
  if (preset !== null) {
    const found = DATE_PRESETS.find((p) => p.id === preset);
    if (found) return found.chipLabel;
  }

  let dateStr: string;
  if (startDate.isSame(endDate, 'day')) {
    dateStr = formatDate(startDate);
  } else if (
    startDate.month() === endDate.month() &&
    startDate.year() === endDate.year()
  ) {
    dateStr = `${startDate.date()} – ${endDate.date()} ${
      MONTHS_SHORT_RU[endDate.month()]
    }`;
  } else {
    dateStr = `${formatDate(startDate)} – ${formatDate(endDate)}`;
  }

  if (isAllDay) return dateStr;
  return `${dateStr}, ${startTime}–${endTime}`;
};

export const addMinutesToTime = (time: string, minutes: number): string => {
  const [h, m] = time.split(':').map(Number);
  const total = Math.min(h * 60 + m + minutes, 23 * 60 + 59);
  return `${pad(Math.floor(total / 60))}:${pad(total % 60)}`;
};
